module.exports = __webpack_public_path__ + "static/media/content-onboarding_02.c5a24eb5.png";